import { RegulationsHeader } from '~/components/header/regulations-header/index.js';

export default RegulationsHeader;
